var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 20,
    height: 20,
    transform: "translate(14.815 14.71)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_47",
    "data-name": "Mask Group 47",
    transform: "translate(-14.815 -14.71)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(14.148 14.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 18.667,
    height: 18.667,
    rx: 2.667,
    transform: "translate(1.333 1.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M13.333,16V9.333",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M16,16V5.333",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M5.333,16V13.333",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M8,10.667V16",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M10.667,12v4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolBox);
export default __webpack_public_path__ + "static/media/toolBox.5629dd356b6ed6a6abcc43c89815f2d8.svg";
export { ForwardRef as ReactComponent };